<div id="mySidenav" class="sidenav">
    <a class="nav-link scrollto" [routerLink]="['/login']" (click)="handleLogoutClick()">LOGOUT <i
        style="margin-left: 15px;"> |</i></a>
  </div>